import gql from 'graphql-tag';

const GET_ALL_WORKLOGS = gql`
  query getWorklogs($ticketId: ID, $projectId: ID) {
    getWorklogs(ticketId: $ticketId, projectId: $projectId) {
      worklogId
      worklogDate
      technician {
        userId
        name
        firstName
        lastName
      }
      notes
      createdTime
      worklogItems {
        itemId
        status
        afterHours
        serviceItem {
          itemId
          name
          quantityType
        }
        billable
        afterHours
        qty
      }
    }
  }
`;

const GET_CURRENT_WORKLOG = gql`
  query getWorklog($worklogId: ID) {
    getWorklog(worklogId: $worklogId) {
      worklogId
      technician {
        userId
        name
        firstName
        lastName
      }
      notes
      createdTime
      worklogItems {
        itemId
        status
        afterHours
        serviceItem {
          itemId
          name
          quantityType
          roundUpValue
          unitPrice
          businessHoursUnitPrice
          afterHoursUnitPrice
          useAsWorklogItem
          quantity
        }
        billable
        qty
      }
    }
  }
`;

const GET_ALL_WORKLOG_TIMERS = gql`
  query getWorklogTimers($ticketId: ID, $projectId: ID) {
    getWorklogTimers(ticketId: $ticketId, projectId: $projectId) {
      timerId
      serviceItem {
        itemId
        name
        quantityType
        roundUpValue
        unitPrice
        businessHoursUnitPrice
        afterHoursUnitPrice
        useAsWorklogItem
        quantity
      }
      billable
      technician {
        userId
        name
        firstName
        lastName
      }
      state
      timespent
      timespentAfterHours
    }
  }
`;

const GET_WHITELISTED_SERVICE_ITEMS = gql`
  query getWhitelistedServiceItems($clientId: ID!, $listInfo: ListInfoInput) {
    getWhitelistedServiceItems(clientId: $clientId, listInfo: $listInfo) {
      items {
        itemId
        name
        invoiceDescription
        quantityType
        roundUpValue
        unitPrice
        category {
          categoryId
          name
        }
        businessHoursUnitPrice
        afterHoursUnitPrice
        useAsWorklogItem
        quantity
        salesTaxEnabled
        salesTax {
          taxId
          name
          rates {
            rateId
            name
            rateValue
          }
        }
        integrationState {
          xero
          quickbooks
          pax8
        }
      }
      customPriceItems
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_WHITELISTED_SERVICE_ITEMS_LIST = gql`
  query getWhitelistedServiceItems($clientId: ID!, $listInfo: ListInfoInput) {
    getWhitelistedServiceItems(clientId: $clientId, listInfo: $listInfo) {
      items {
        itemId
        name
        invoiceDescription
        quantityType
        roundUpValue
        unitPrice
        category {
          categoryId
          name
        }
        businessHoursUnitPrice
        afterHoursUnitPrice
        useAsWorklogItem
        quantity
        salesTaxEnabled
        integrationState {
          xero
          quickbooks
          pax8
        }
      }
      customPriceItems
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

export {
  GET_ALL_WORKLOGS,
  GET_CURRENT_WORKLOG,
  GET_ALL_WORKLOG_TIMERS,
  GET_WHITELISTED_SERVICE_ITEMS,
  GET_WHITELISTED_SERVICE_ITEMS_LIST
};
